// carousel.js - Carousel functionality module

// Show a specific slide
export function showSlide(slides, indicators, index) {
  // Reset all slides and indicators
  slides.forEach((slide) => {
    slide.classList.remove("opacity-100");
    slide.classList.add("opacity-0");
  });

  indicators.forEach((indicator) => {
    indicator.classList.add("bg-white/50");
    indicator.classList.remove("bg-white");
  });

  // Show selected slide and update indicator
  slides[index].classList.remove("opacity-0");
  slides[index].classList.add("opacity-100");
  indicators[index].classList.remove("bg-white/50");
  indicators[index].classList.add("bg-white");

  return index;
}

// Go to next slide
export function nextSlide(slides, indicators, currentSlide) {
  let next = currentSlide + 1;
  if (next >= slides.length) next = 0;
  return showSlide(slides, indicators, next);
}

// Go to previous slide
export function prevSlide(slides, indicators, currentSlide) {
  let prev = currentSlide - 1;
  if (prev < 0) prev = slides.length - 1;
  return showSlide(slides, indicators, prev);
}

// Start auto rotation
export function startSlideInterval(callback) {
  return setInterval(callback, 5000);
}

// Stop auto rotation
export function stopSlideInterval(interval) {
  clearInterval(interval);
}

// Initialize the carousel
export function initCarousel() {
  const slides = document.querySelectorAll(".slide");
  const indicators = document.querySelectorAll(".indicator");
  const prevBtn = document.getElementById("prev-btn");
  const nextBtn = document.getElementById("next-btn");
  let currentSlide = 0;
  let slideInterval;

  // Show first slide
  currentSlide = showSlide(slides, indicators, 0);

  // Start auto rotation
  slideInterval = startSlideInterval(() => {
    currentSlide = nextSlide(slides, indicators, currentSlide);
  });

  // Event listeners for indicators
  indicators.forEach((indicator, index) => {
    indicator.addEventListener("click", () => {
      stopSlideInterval(slideInterval);
      currentSlide = showSlide(slides, indicators, index);
      slideInterval = startSlideInterval(() => {
        currentSlide = nextSlide(slides, indicators, currentSlide);
      });
    });
  });

  // Event listeners for navigation buttons
  nextBtn.addEventListener("click", () => {
    stopSlideInterval(slideInterval);
    currentSlide = nextSlide(slides, indicators, currentSlide);
    slideInterval = startSlideInterval(() => {
      currentSlide = nextSlide(slides, indicators, currentSlide);
    });
  });

  prevBtn.addEventListener("click", () => {
    stopSlideInterval(slideInterval);
    currentSlide = prevSlide(slides, indicators, currentSlide);
    slideInterval = startSlideInterval(() => {
      currentSlide = nextSlide(slides, indicators, currentSlide);
    });
  });

  // Pause on hover
  const carousel = document.querySelector(".carousel");
  carousel.addEventListener("mouseenter", () => {
    stopSlideInterval(slideInterval);
  });
  carousel.addEventListener("mouseleave", () => {
    slideInterval = startSlideInterval(() => {
      currentSlide = nextSlide(slides, indicators, currentSlide);
    });
  });

  return {
    slides,
    indicators,
    currentSlide,
    slideInterval,
  };
}
